(ns common.schema.entities.activity
  (:require
   [common.schema.schema-utils :as su]))

(def activity-entity-types
  [:entity.type/note
   :entity.type/note-call
   :entity.type/note-meeting
   :entity.type/note-message
   :entity.type/email])

(def new-activity
  (concat
   (su/option-field-multi :activity/tag-tags "Tags" {:default-field-visibility :in-use-disabled})
   (su/option-field :activity/topic "Topic" {:default-field-visibility :in-use-disabled})
   (su/option-field :activity/event "Event" {:default-field-visibility :in-use-disabled})))
